import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IGetNoePelakByHarfPelakQuery } from '../Queries/IGetNoePelakByHarfPelakQuery';

export const getSerialHayePelakByHarfPelak = createAsyncThunk(
  'SerialHayePelakByHarf/GetAll',
  async (query: IGetNoePelakByHarfPelakQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.AnvaePelak.GetSerialHayePelakByHarfPelak}`,
      params: query,
    });
  }
);
